<!--
Author: Lsc
Date: 2019-07-25
Desc: 更新证件信息组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-modify-info bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row class="investor-data-up">
            <el-alert :title="ocrTitle" type="warning" show-icon :closable="false" />
            <ocr-upd-modify v-if="!isIE9 && certificatetype == '00'" />
            <ocr-upd-other-modify v-else-if="!isIE9 && certificatetype != '00'" />
            <div v-else class="cant-up">
                <div class="cant-info">
                    为保证上传证件质量，暂不支持IE9浏览器上传认证证件照，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。
                </div>
                <el-button class="medium" v-on:click="$router.back()">确定</el-button>
            </div>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import ocrUpdModify from "@/components/form/ocrUpdModify.vue";
import ocrUpdOtherModify from "@/components/form/ocrUpdOtherModify.vue";
export default {
    name: "OcrInfoUpd",
    components: {
        ocrUpdModify,
        ocrUpdOtherModify
    },
    mixins: [mixin],
    data() {
        return {
            isIE9: false,
            certificatetype: ""
        };
    },
    computed: {
        ocrTitle() {
            return (
                "注意：上传的图片大小每张不能超过" +
                this.$cache.getOcrFileSize() +
                "M，格式类型只支持bmp，jpg，jpeg，png，非身份证请至少上传两张有效证件照。"
            );
        }
    },
    created() {
        this.certificatetype = this.$route.query.certificatetype;
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.cant-info {
    text-align: center;
    font-size: 18px;
    color: #333333;
    line-height: 30px;
    margin: 20px auto;
}
.cant-up {
    margin: 30px auto;
    width: 100%;
    text-align: center;
}
</style>
